import L from "leaflet";
import React, { Component } from "react";
import { style } from "typestyle";
import config from "../../config";

interface IBaseLayer {
  id: string;
  tilesUrl: string;
  attribution: string;
  maxNativeZoom: number;
  tileSize: 256 | 512;
  zoomOffset: number;
}

export const OSM_RASTER_LAYER: IBaseLayer = {
  id: "map",
  tilesUrl: "//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  attribution:
    '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
  maxNativeZoom: 19,
  tileSize: 256,
  zoomOffset: 0,
};

export const MAPBOX_SATELLITE: IBaseLayer = {
  id: "satellite",
  tilesUrl:
    "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=" +
    config.mapboxKey,
  attribution:
    '&copy; <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>' +
    " | " +
    '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
  maxNativeZoom: 17,
  tileSize: 512,
  zoomOffset: -1,
};

const createBaseLayer = ({
  tilesUrl,
  maxNativeZoom,
  attribution,
  tileSize,
  zoomOffset,
}: IBaseLayer) =>
  L.tileLayer(tilesUrl, {
    maxNativeZoom,
    maxZoom: 26,
    attribution,
    tileSize,
    zoomOffset,
  });

interface IMapBaseLayersControlProps {
  layers: IBaseLayer[];
  map: L.Map;
}
interface IMapBaseLayersControlState {
  currentLayerIndex: number;
  layers: L.Layer[];
}
export default class MapBaseLayersControl extends Component<
  IMapBaseLayersControlProps,
  IMapBaseLayersControlState
> {
  state = {
    currentLayerIndex: 0,
    layers: [],
  };

  componentDidMount(): void {
    const { layers } = this.props;
    const leafletLayers = layers.map(createBaseLayer);
    this.setState(
      {
        layers: leafletLayers,
      },
      () => this.updateMapLayers(),
    );
  }

  handleClick = (): void => {
    this.setState(
      {
        currentLayerIndex: this.getNextIndex(),
      },
      () => this.updateMapLayers(),
    );
  };

  getNextIndex(): number {
    const nextIndex = this.state.currentLayerIndex + 1;
    return nextIndex >= this.props.layers.length ? 0 : nextIndex;
  }

  updateMapLayers(): void {
    const { map } = this.props;
    const { layers } = this.state;
    layers.map(l => map.hasLayer(l) && map.removeLayer(l));
    map.addLayer(layers[this.state.currentLayerIndex]);
  }

  render(): JSX.Element {
    const nextLayer = this.props.layers[this.getNextIndex()];
    return (
      <div
        className={style({
          width: "40px",
          height: "40px",
          background: "white",
          backgroundSize: "cover",
          boxShadow:
            "0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)",
          cursor: "pointer",
        })}
        style={{ backgroundImage: `url('baselayer-${nextLayer.id}.png')` }}
        onClick={this.handleClick}
      />
    );
  }
}
